module.exports = __webpack_public_path__ + "static/media/shown.6ecf9f51.svg";